export function formatCurrency(value: undefined): string;
export function formatCurrency(value: null): string;
export function formatCurrency(value: string): string;
export function formatCurrency(value: number): string;
export function formatCurrency(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    value = Number(value ?? 0);
  }

  // Redondear a dos decimales
  const roundedValue = Math.round(value * 100) / 100;

  // Separar la parte entera y decimal
  const [integerPart, decimalPart] = roundedValue.toFixed(2).split(".");

  // Formatear la parte entera con separadores de miles
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Combinar las partes y agregar el símbolo de peso
  let result = `$${formattedIntegerPart}`;

  // Agregar la parte decimal solo si no es cero
  if (decimalPart !== "00") {
    result += `,${decimalPart}`;
  }

  return result;
}

export function calculatePercentageDiscount({
  priceDiscount,
  priceOriginal,
}: {
  priceDiscount: number;
  priceOriginal: number;
}): number {
  const price = Number(priceDiscount ?? 0);
  const originalPrice = Number(priceOriginal ?? 0);

  if (originalPrice === 0 || price >= originalPrice) {
    return 0;
  }

  const result = (originalPrice - price) / originalPrice;
  return Math.round(result * 100);
}
